module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/arrow-right-07674a21a0ce6fadcf2acfdbe84f1aa4.svg";